

import axiosClient from "./axiosClient";

const locationTourApi = {

    getByCountryId: (params) =>{
        const url = `api/locationTour/getByCountry/${params}`
        return axiosClient.get(url,params)
    },

    getById: (params, language) =>{
        const url = `api/locationTour/${params}/${language}`
        return axiosClient.get(url,params, language)
    },

    getAll: (body) =>{
        const url = `api/locationTour/getall`
        return axiosClient.post(url,body)
    },

    createLocationTour: (params) =>{
        const url = `api/locationTour/create`
        return axiosClient.post(url,params,  {
            useAuthorize: true
        })
    },

    
    updateLocationTour: (params,data) =>{
        const url = `api/locationTour/${params}`
        return axiosClient.put(url,data, {
            useAuthorize: true
        })
    },
    
    calculateCoord: (data) =>{
        const url = `api/calculate`
        return axiosClient.post(url,data)
    },

    deleteLocationTourById: (params) =>{
        const url = `api/locationTour/${params}`
        return axiosClient.delete(url, {
            useAuthorize: true
        })
    },
    getNearestLocation: (data) => {
        const url = `api/locationTour/getallnearest`
        return axiosClient.post(url,data)
    },
    getAdsTour: (language) => {
        const data = {    
            language: language,
            ads: true
        };
        const url = `api/locationTour/getads`
        return axiosClient.post(url, data)
    }
}
export default locationTourApi;